import { HTMLAttributes } from "react";

interface AddressDisplayProps extends HTMLAttributes<HTMLDivElement> {
  company?: string;
  firstName?: string;
  lastName?: string;
  addressLine1: string;
  addressLine2?: string;
  zip: string;
  city: string;
  country?: string;
}

export default function AddressDisplay({ company, firstName, lastName, addressLine1, addressLine2, zip, city, country, className }: AddressDisplayProps) {
  return (
    <div className={className}>
      {company && company.length > 0 && (
        <>
          {company}<br />
        </>
      )}
      {firstName && firstName.length > 0 && lastName && lastName.length > 0 && (
        <>
          {`${firstName} ${lastName}`}
          <br />
        </>
      )}
      {addressLine1}<br />
      {addressLine2 && addressLine2.length > 0 && (
        <>
          {addressLine2}<br />
        </>
      )}
      {zip} {city}
      {country && country.length > 0 && (
        <>
          <br />{country}
        </>
      )}
    </div>
  );
}
